import * as api from '../api'
import { startLoading, endLoading, setPosts } from '../reducers/postSlice'

export const fetchAllPosts = async(dispatch) => {
    try{
        dispatch({ type: startLoading.type })
        const { data } = await api.fetchAllPosts
        dispatch({
            type: setPosts.type,
            payload: data
        })
        dispatch({ type: endLoading.type })
        return data
    }catch(error){
        // console.log(error)
        // console.log("Axios error:", error);
        // if (error.response) {
        //     console.log("Error status:", error.response.status);
        //     return error.response; // Return the error response object
        // } else {
        //     console.log("Error details:", error.message);
        //     throw error; 
        // }
    }
}